export default {
  name: 'SanityPageHeader',
  props: {
    fixed: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onSignupClick() {
      this.$router.push({
        path: '/application',
        query: {
          device_tag: window.g_device_tag
        }
      });
    }
  }
};